
import { combineReducers } from 'redux';
import { AuthActionTypes } from './auth/constants';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import areaReducer from './areas/reducers'
import hospitalReducer from './hospitals/reducers'
import directoryReducer from './directories/reducers';
import userReducer from './users/reducers';
import enterpriseReducer from './enterprises/reducers';
import patientReducer from './patients/reducers';
import attendanceReducer  from './attendance/reducers';
import patientScaleReducer from './scales/reducers';
import providerReducer from './providers/reducers';
import equipmentReducer from './equipments/reducers';
import folioReducer from './folios/reducers';
import requirementReducer from './requirements/reducers';
import studyReducer from './studies/reducers';
import treatingDoctorReducer from './doctors/reducers';
import noteReducer from './notes/reducers';
import scheduleReducer  from './schedules/reducers';
/*
import Protocol from './protocols/reducers';



import RequirementImaging from './imaging/reducers';
import RequirementLaboratory from './laboratory/reducers';
import StudyImaging from './studies/reducers';
import MedicalNote from './notes/reducers';

import Files from './files/reducers';
*/
const appReducer = combineReducers({
    Auth,
    Layout,
    areaReducer,
    hospitalReducer,
    directoryReducer,
    userReducer,
    enterpriseReducer,
    patientReducer,
    attendanceReducer,
    patientScaleReducer,
    providerReducer,
    equipmentReducer,
    folioReducer,
    requirementReducer,
    studyReducer,
    treatingDoctorReducer,
    noteReducer,
    scheduleReducer
});

// El cierre de sesión descarta datos del usuario anterior en todos los módulos.
export default function rootReducer(state: ReturnType<typeof appReducer> | undefined, action: Parameters<typeof appReducer>[1]) {
    return appReducer(action.type === AuthActionTypes.LOGOUT_USER ? undefined : state, action);
}
